import React from "react";
import { Outlet } from "react-router-dom";
import KidsBottomNav from "../Kids/KidsBottomNav";

// Mounts the persistent bottom tab bar once around the Kids Zone's three
// tab destinations (hub, watch, progress) instead of each page building
// its own nav. Gameplay routes (/kids/games/quiz/:slug etc.) stay outside
// this shell — the tab bar would just be a mis-tap risk during a game.
//
// The bottom bar itself is mobile/tablet-only (see KidsBottomNav's
// `lg:hidden`) — desktop already has the hub's persistent sidebar, so the
// reserved bottom padding here matches that breakpoint too, otherwise
// desktop would carry dead space at the bottom for a bar that isn't shown.
export default function KidsShell() {
  return (
    <div className="min-h-screen">
      <div className="pb-[calc(78px+env(safe-area-inset-bottom))] lg:pb-0">
        <Outlet />
      </div>
      <KidsBottomNav />
    </div>
  );
}
